import { alpha, styled } from "@mui/material";
import { Layers as LayersIcon } from "@mui/icons-material";

import { FallbackProps } from "react-error-boundary";

import { useQueryErrorResetBoundary } from "react-query";

interface Props extends FallbackProps {}

export function LayerPreviewFallBack(props: Props) {
  const { resetErrorBoundary } = props;
  const { reset } = useQueryErrorResetBoundary();

  function tryAgain() {
    reset();
    resetErrorBoundary();
  }

  return (
    <Styles onClick={tryAgain}>
      <LayersIcon />
    </Styles>
  );
}

const Styles = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 140px;
  background-color: ${({ theme }) => alpha(theme.palette.common.white, 0.4)};
`;
